import { handleTokenInvalidation } from './tokenHandler';

export async function administratorApi(action, body = {}) {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('请先登录');
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(`https://server.battleverse.cn/admin/administrators/${action}.do`, {
      method: 'POST', cache: 'no-store', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body)
    });
    const result = await response.json();
    if (result.code === -2) handleTokenInvalidation();
    if (!response.ok || !result.success) {
      const error = new Error(result.msg || '操作失败，请重试');
      error.code = result.code;
      throw error;
    }
    return result;
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('请求超时，请刷新确认当前权限后重试');
    throw error;
  } finally { clearTimeout(timeout); }
}
